var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.63121 0.0332031C3.72753 0.0332031 0.553711 3.20702 0.553711 7.11071V42.4982C0.553711 46.4019 3.72753 49.5757 7.63121 49.5757H43.0187C46.9224 49.5757 50.0962 46.4019 50.0962 42.4982V7.11071C50.0962 3.20702 46.9224 0.0332031 43.0187 0.0332031H7.63121ZM40.4863 9.32242L29.0075 22.4379L42.51 40.2865H31.938L23.6662 29.4601L14.189 40.2865H8.93613L21.2112 26.2531L8.26155 9.32242H19.099L26.5856 19.2199L35.2335 9.32242H40.4863ZM36.3062 37.1459L17.5176 12.2972H14.388L33.3867 37.1459H36.2951H36.3062Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/x-icon.e37e0655eeb6e2765fdb1ef4281d3673.svg";
export { ForwardRef as ReactComponent };